import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navigation } from "@/components/Navigation";
import { IntroSection } from "@/components/sections/IntroSection";
import { DiagnosisZone } from "@/components/sections/DiagnosisZone";
import { RemovalSection } from "@/components/sections/RemovalSection";
import { ClaritySection } from "@/components/sections/ClaritySection";
import { ComparisonSection } from "@/components/sections/ComparisonSection";
import { ImpactSection } from "@/components/sections/ImpactSection";
import { ProcessSection } from "@/components/sections/ProcessSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { Footer } from "@/components/sections/Footer";

const ClarityAudit = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        {/* Zone B - Resolution: Intro */}
        <IntroSection />
        
        {/* Zone A - Diagnosis: Problem + Friction + Scorecard (warm grey, continuous) */}
        <DiagnosisZone />
        
        {/* Zone B - Resolution: All solution content (pure white) */}
        <RemovalSection />
        <ClaritySection />
        <ComparisonSection />
        <ImpactSection />
        <ProcessSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClarityAudit />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </>
  );
}

export default App;
